// extracted by mini-css-extract-plugin
export default {"warning_modal":"warningMessage_warning_modal__SJ+RW","warning_modal__button":"warningMessage_warning_modal__button__Kah-f"};